module.exports = __webpack_public_path__ + "img/icon68.bd5a1ecf.png";